import React from 'react'
import { useInView } from 'react-intersection-observer'
import { useSelector } from 'react-redux'

import Slider from '../slider'
import OfferCard from '../cards/offerCard'

import trads from '../../intl/trads.json'

const SliderOffers = ({data, type = 'reg'}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const items = data && data.offers ? data.offers : data ? data : null
  const lang = useSelector(state => state.lang)

  return (
    <>
      { items &&
        <div className={inView ? 'has-anim' : ''} ref={ref}>
          <h2 className="title title-slice slider-cards-title">
            {type !== 'bottomPage'
              ? <>
                  {trads[lang].solutions.titleSlider1}
                  <span className="font-normal block"> {trads[lang].solutions.titleSlider2}</span>
                  </>
              :  trads[lang].solutions.titleSliderBottom
            }
          </h2>

          <div className="slider-cards slider-cards--offers">
            { items !== undefined && items.length > 0 &&
              <Slider
                nbItems={items.length}
                hasCards="true"
                options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 1.25, "spaceBetween": 24 }, "1024": { "slidesPerView": 1.5, "spaceBetween": 32 }, "1280": { "slidesPerView": 2, "spaceBetween": 32 }} }'
                name="offers">
                { items.map((offer, i) => { 
                  return(
                    <div className={`scroll-anim-el flex w-full scroll-anim-el--${i + 1}`} key={i}>
                      <OfferCard offer={offer} />
                    </div>
                  )
                }) }
              </Slider>
            }
          </div>
        </div>
      }
    </>
  )
}

export default SliderOffers